import React from "react";
import AuthService from "./AuthService";

function formatLoginTime(value) {
  if (!value) return "Not available";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "Not available";
  }

  return date.toLocaleString();
}

export default function ProfileSettings() {
  const user = AuthService.getCurrentUser();
  const loginTime = localStorage.getItem("login_time");

  return (
    <section className="profile-page">
      <header>
        <p>My account</p>
        <h1>Profile settings</h1>
        <span>
          Review your identity, role, branch and current
          session details.
        </span>
      </header>

      <div className="profile-card">
        <div className="profile-card__avatar">
          {user?.profile_picture ? (
            <img
              src={user.profile_picture}
              alt={user.full_name || "User"}
            />
          ) : (
            <span>
              {(user?.first_name?.[0] ||
                user?.full_name?.[0] ||
                user?.email?.[0] ||
                "U")
                .toUpperCase()}
            </span>
          )}
        </div>

        <div className="profile-card__identity">
          <h2>
            {user?.full_name || user?.email || "User"}
          </h2>
          <p>{user?.email || user?.policy_number}</p>
        </div>

        <div className="profile-information-grid">
          <div>
            <span>Role</span>
            <strong>
              {user?.role?.name ||
                user?.user_type ||
                "Not assigned"}
            </strong>
          </div>

          <div>
            <span>Branch</span>
            <strong>
              {user?.branch?.name ||
                (user?.is_head_office_user
                  ? "Head Office"
                  : "Not assigned")}
            </strong>
          </div>

          <div>
            <span>Signed in</span>
            <strong>{formatLoginTime(loginTime)}</strong>
          </div>

          <div>
            <span>Account status</span>
            <strong>{user?.status || "ACTIVE"}</strong>
          </div>
        </div>

        <div className="profile-notice">
          <i className="bi bi-info-circle"></i>
          <p>
            Profile editing, password changes and profile
            pictures will be connected to the backend user
            management screen in the next security patch.
          </p>
        </div>
      </div>
    </section>
  );
}
